<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">
            Contas a Receber
          </h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Exibindo registros de {{ pagination.FilterInitialDueDate | date }} até {{ pagination.FilterFinalDueDate | date }}.</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Vencimento</th>
                    <th scope="col" class="border-0 text-left">Categoria / Descrição</th>
                    <th scope="col" class="border-0 text-left">Fornecedor</th>
                    <th scope="col" class="border-0">Valor</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(receivable, index) in accountsreceivable" :key="index">
                    <td>
                      <img v-if="receivable.Bank.Code == '001'" src="@/assets/images/bank_0001.png" height="32px" width="32px" class="logo" />
                      <img v-if="receivable.Bank.Code == '033'" src="@/assets/images/bank_0033.png" height="32px" width="32px" class="logo" />
                      <img v-if="receivable.Bank.Code == '041'" src="@/assets/images/bank_0041.png" height="32px" width="32px" class="logo" />
                      <img v-if="receivable.Bank.Code == '104'" src="@/assets/images/bank_0104.png" height="32px" width="32px" class="logo" />
                      <img v-if="receivable.Bank.Code == '237'" src="@/assets/images/bank_0237.jpg" height="32px" width="32px" class="logo" />
                      <img v-if="receivable.Bank.Code == '341'" src="@/assets/images/bank_0341.png" height="32px" width="32px" class="logo" />
                      <img v-if="receivable.Bank.Code == '422'" src="@/assets/images/bank_0422.png" height="32px" width="32px" class="logo" />
                      <img v-if="receivable.Bank.Code == '745'" src="@/assets/images/bank_0745.png" height="32px" width="32px" class="logo" />
                      <img v-if="receivable.Bank.Code == '748'" src="@/assets/images/bank_0748.png" height="32px" width="32px" class="logo" />


                    <td style="vertical-align: middle;">{{ receivable.DueDate | date }}</td>
                    

                    <td class="text-left">
                      
                      
                      {{ receivable.Category.Name }}<br />
                      <small>{{ receivable.Description }}</small>
                    </td>



                    <td class="text-left" style="vertical-align: middle;">{{ receivable.SupplierName }}</td>
                    <td style="vertical-align: middle;">{{ receivable.Amount | currency }}</td>
                    <td class="text-left" style="vertical-align: middle;">{{ receivable.PaymentDate | date }}</td>
                    
                    <td style="vertical-align: middle;">
                      <span v-if="receivable.Conciliated" class="badge badge-success">Conciliado</span>
                      <span v-if="!receivable.Conciliated" class="badge badge-danger">Não Conciliado</span>
                    </td>
                    
                  </tr>
                  <tr
                    v-if="
                      accountsreceivable == undefined ||
                      accountsreceivable == null ||
                      accountsreceivable.length == 0
                    "
                  >
                    <td colspan="7">A pesquisa realizada não encontrou nenhum registro. <br/>Experimente alterar os filtros aplicados.</td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormOutgo"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <loader :is-loading="loadingModal"></loader>

      <div v-if="!loadingModal">
        <!-- Steps -->
        <nav
          class="nav-steps"
          aria-label="breadcrumb"
          v-if="isSeeing && infoOutgo.OutgoPeriods.length > 1"
        >
          <ol
            style="background-color: #fff; padding: 0.75rem 0rem"
            class="breadcrumb"
          >
            <li class="breadcrumb-item">
              <a
                class="black-text"
                href="#"
                v-on:click="mCurrentStep = 0"
                :class="[mCurrentStep == 0 ? 'active' : '']"
                >Detalhes</a
              >
            </li>

            <li class="breadcrumb-item">
              <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
              <a
                class="black-text"
                href="#"
                v-on:click="mCurrentStep = 1"
                :class="[mCurrentStep == 1 ? 'active' : '']"
                >Histórico de Valores</a
              >
            </li>
          </ol>
        </nav>

        <!-- Step 0 -->
        <div v-if="mCurrentStep === 0">
          <ValidationObserver tag="form" ref="OutgoValidationForm">
            <!-- Description -->
            <d-form-row>
              <d-col md="12" class="form-group">
                <label>Tipo de despesa</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <d-select
                    :class="validatedOutgoForm | showValidateError(invalid)"
                    v-model="infoOutgo.OutgoType.Code"
                    :disabled="true"
                  >
                    <option :value="null" selected>Selecione</option>
                    <option
                      v-for="type in outgoTypes"
                      v-bind:value="type.Code"
                      v-bind:key="type.Code"
                    >
                      {{ type.Name }}
                    </option>
                  </d-select>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedOutgoForm"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <d-form-row>
              <d-col md="12" class="form-group">
                <label>Descrição</label>
                <ValidationProvider
                  rules="required|min:4"
                  v-slot="{ errors, invalid }"
                >
                  <d-form-input
                    type="text"
                    :class="validatedOutgoForm | showValidateError(invalid)"
                    v-model="infoOutgo.Description"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedOutgoForm"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <!-- Amount -->
            <d-form-row>
              <d-col md="12" class="form-group">
                <label>Valor</label>
                <ValidationProvider
                  rules="required|min_value:0.01"
                  v-slot="{ errors, invalid }"
                >
                  <currency-input
                    class="form-control"
                    :class="validatedOutgoForm | showValidateError(invalid)"
                    v-model="infoOutgo.Amount"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedOutgoForm"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <d-form-row v-if="AmountWasChanged">
              <d-col md="12" class="form-group">
                <label>
                  Data Inicial
                  <i
                    class="far fa-question-circle ml-1"
                    style="font-size: 13px"
                    v-b-tooltip.hover.bottom
                    title="Data em que novo valor (acima) entrará em vigor. Até a data estipulada o valor antigo será utilizado."
                  ></i>
                </label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <date-field
                    :inputClass="validatedOutgoForm | showValidateError(invalid)"
                    v-model="infoOutgo.InitialDate"
                    :minDate="$options.filters.addDay(new Date(), -20)"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedOutgoForm"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <d-form-row v-if="codeOutgoType == '1'">
              <!-- DueDate -->
              <d-col md="6" class="form-group">
                <label>Data de vencimento</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <date-field
                    v-model="infoOutgo.DueDate"
                    v-bind:inputClass="
                      validatedOutgoForm | showValidateError(invalid)
                    "
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedOutgoForm"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
              <!-- PaymentDate -->
              <d-col md="6" class="form-group">
                <label>Data de pagamento</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, invalid }"
                >
                  <date-field
                    v-model="infoOutgo.PaymentDate"
                    v-bind:inputClass="
                      validatedOutgoForm | showValidateError(invalid)
                    "
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedOutgoForm"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <!-- DueDay -->
            <d-form-row v-else>
              <d-col md="12" class="form-group">
                <label>Dia de vencimento</label>
                <ValidationProvider
                  rules="required|min_value:1"
                  v-slot="{ errors, invalid }"
                >
                  <d-input
                    type="number"
                    :class="validatedOutgoForm | showValidateError(invalid)"
                    v-model="infoOutgo.DueDay"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedOutgoForm"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <!-- Name -->
            <d-form-row>
              <d-col md="12" class="form-group">
                <label>{{ labelName }}</label>
                <ValidationProvider rules="min:3" v-slot="{ errors, invalid }">
                  <d-form-input
                    type="text"
                    v-model="infoOutgo.Name"
                    :disabled="isSeeing"
                    :class="validatedOutgoForm | showValidateError(invalid)"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedOutgoForm"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
            <!-- Identity -->
            <d-form-row>
              <d-col md="12" class="form-group">
                <label>CPF/CNPJ</label>
                <ValidationProvider rules="min:11" v-slot="{ errors, invalid }">
                  <the-mask
                    class="form-control"
                    :class="validatedOutgoForm | showValidateError(invalid)"
                    type="tel"
                    :mask="['###.###.###-##', '##.###.###/####-##']"
                    v-model="infoOutgo.Identity"
                    :disabled="isSeeing"
                  />
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedOutgoForm"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </d-col>
            </d-form-row>
          </ValidationObserver>
        </div>

        <!-- Step 1 -->
        <div v-if="mCurrentStep === 1">
          <!-- Table amount history (OutgoPeriod) -->
          <table class="table mb-0">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th scope="col" class="border-0">Data Inicial</th>
                <th scope="col" class="border-0">Data Final</th>
                <th scope="col" class="border-0">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(outgoPeriod, index) in infoOutgo.OutgoPeriods"
                :key="index"
              >
                <td>{{ outgoPeriod.InitialDate | date }}</td>
                <td v-if="outgoPeriod.EndDate !== '-'">
                  {{ outgoPeriod.EndDate | date }}
                </td>
                <td v-else class="text-center">-</td>
                <td>{{ outgoPeriod.Amount | currency }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveOutgo()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeOutgoType" :disabled="true">
            <option
              v-for="type in outgoTypes"
              v-bind:key="type.Code"
              v-bind:value="type.Code"
            >
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>

      </d-form-row> -->
        


      <d-form-row>
        <d-col md="6" class="form-group">
          <date-field v-model="filter.FilterInitialDueDate"></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <date-field v-model="filter.FilterFinalDueDate"></date-field>
        </d-col>
      </d-form-row>

      

      <d-form-row>
          <d-col md="6" class="form-group">
          <input
            placeholder="Nome do Fornecedor"
            type="text"
            class="form-control"
            v-model="filter.SupplierName"
            v-on:keyup.enter="Filter()"
          />
        </d-col>

        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            placeholder="Documento do Fornecedor"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.SupplierIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>

     





      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mEnableOutgo"
      title="Ativar despesa"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col>
          <label>Data de início da despesa</label>
          <date-field
            v-model="infoOutgoEnable.InitialDate"
            :minDate="$options.filters.addMonth(new Date(), 0)"
          />
        </d-col>
      </d-form-row>

      <template v-slot:modal-footer="{ cancel }">
        <b-button size="sm" variant="secondary" @click="cancel()"
          >Cancelar</b-button
        >
        <b-button
          size="sm"
          variant="success"
          v-b-tooltip.hover.bottom
          title="Ativar despesa"
          @click="ProcessUpdateEnabled(null, null, true)"
          >Ativar</b-button
        >
      </template>
    </b-modal>

  </div>
</template>

<script>
import { hasValue } from "../../../utils/functions.js";
import dateField from "../../common/date-field";
export default {
  name: "accountsreceivable",
  components: {
    dateField,
  },
  data: function () {
    return {
      OriginalAmount: null,
      countFilter: 1,
      
      

      filter: {
        FilterInitialDueDate: this.$options.filters.date(new Date().setDate(new Date().getDate()), "YYYY-MM-DD"),
        FilterFinalDueDate: this.$options.filters.date(new Date(new Date().setFullYear(new Date().getFullYear() + 1)), "YYYY-MM-DD"),
        Category: { Id: 0 },
        SupplierName: null,
        SupplierIdentity: null,
      },
      infoOutgo: {
        OutgoType: {
          Code: this.$route.params.codeOutgoType,
        },
        Amount: null,
        Description: null,
        DueDate: null,
        PaymentDate: null,
        DueDay: 0,
        Identity: null,
        InitialDate: null,
        Name: null,
        OutgoPeriods: [],
      },
      infoOutgoEnable: {
        InitialDate: null,
        Idx: null,
      },
      idOutgo: 0,
      isSeeing: false,
      labelIdentity: "CPF/CNPJ",
      labelName: "Fornecedor",
      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      mCurrentStep: 0,
      modalTitle: "Nova despesa",
      accountsreceivable: [],
      outgoTypes: [],
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalAmount: 0,
        TotalItems: 0,
      },
      pOpened: null,
      validatedOutgoForm: false,
    };
  },
  computed: {
    AmountWasChanged() {
      return this.codeOutgoType != '1' && this.infoOutgo.Amount != this.OriginalAmount && this.infoOutgo.Id;
    },
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListAccountsReceivable();
    },
    "pagination.RowsPerPage": function () {
      this.ListAccountsReceivable();
    },
    "infoOutgo.DueDate": function (nv) {
      if (!hasValue(this.infoOutgo.PaymentDate)) {
        this.infoOutgo.PaymentDate = nv;
      }
    },
  },
  mounted() {
    this.ListAccountsReceivable();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListAccountsReceivable();
    },
    filterInvalidDate: function (asToday = false) {
      this.infoOutgo.OutgoPeriods.forEach((op) => {
        const date = new Date(op.EndDate);
        if (date.getUTCFullYear() === 1) {
          op.EndDate = asToday ? new Date() : "-";
        }
      });
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(false);
      this.$store
        .dispatch("ReportOutgo", { params: data })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    OpenOutgo: function (e, i, view) {
      e.preventDefault();
      this.validatedOutgoForm = false;
      this.loadingAddUpdate = false;
      this.mCurrentStep = 0;
      this.ResetInfoOutgo();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idOutgo = this.accountsreceivable[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar despesa";
        this.GetOutgo();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Nova despesa";
        this.ResetInfoOutgo();
      } else {
        // View
        this.pOpened = i;
        this.idOutgo = this.accountsreceivable[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes da despesa";
        this.GetOutgo();
      }
      this.$bvModal.show("mFormOutgo");
    },
    ResetInfoOutgo: function () {
      this.OriginalAmount = null;
      this.infoOutgo = {
        OutgoType: {
          Code: this.codeOutgoType,
        },
        Amount: null,
        Description: null,
        DueDate: null,
        PaymentDate: null,
        DueDay: 0,
        Identity: null,
        InitialDate: null,
        Name: null,
        OutgoPeriods: [],
      };
    },
    SaveOutgo: function () {
      this.validatedOutgoForm = true;

      this.$refs.OutgoValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;
          if (this.pOpened == null) {
            // Add
            this.$store
              .dispatch("AddOutgo", this.infoOutgo)
              .then(() => {
                this.$makeToast(
                  "A despesa foi cadastrada corretamente na base de dados",
                  "success",
                  "Despesa fixa"
                );
                this.ListAccountsReceivable();
                this.$bvModal.hide("mFormOutgo");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao criar a despesa",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.infoOutgo.OutgoPeriods = [];
            this.$store
              .dispatch("UpdateOutgo", this.infoOutgo)
              .then(() => {
                this.$makeToast(
                  "Suas modificações foram salvas na base de dados",
                  "success",
                  "Despesa fixa"
                );
                this.ListAccountsReceivable();
                this.$bvModal.hide("mFormOutgo");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao atualizar a despesa",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetOutgo: function () {
      if (this.idOutgo != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetOutgo", { id: this.idOutgo })
          .then((response) => {
            this.infoOutgo = response;
            this.infoOutgo.InitialDate = this.$options.filters.date(
              new Date(),
              "YYYY-MM-DD"
            );
            this.OriginalAmount = response.Amount;
            this.filterInvalidDate();
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao buscar a despesa",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    GetParamsData: function (deletePagination = false) {
      let data = {
        ...this.pagination,
        ...{
          "Object.FilterInitialDueDate": this.filter.FilterInitialDueDate,
          "Object.FilterFinalDueDate": this.filter.FilterFinalDueDate,
          "Object.Category.Id": this.filter.CategoryId,
          "Object.SupplierName": this.filter.SupplierName,
          "Object.SupplierIdentity": this.filter.SupplierIdentity,
          "Object.OnlyManualInsertion": this.filter.OnlyManualInsertion,
        },
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.RowsPerPage;
        delete data.PageNumber;
      }
      return data;
    },
    ListAccountsReceivable: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.InitialDueDate)) this.countFilter++;
      if (hasValue(this.filter.FinalDueDate)) this.countFilter++;
      if (hasValue(this.filter.CategoryId)) this.countFilter++;
      if (hasValue(this.filter.SupplierName)) this.countFilter++;
      if (hasValue(this.filter.SupplierIdentity)) this.countFilter++;
      this.loadingList = true;
      let data = this.GetParamsData();
      delete data.TotalItems;
      delete data.TotalAmount;
      this.$store
        .dispatch("ListAccountsReceivable", { params: data })
        .then((response) => {
          this.accountsreceivable = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
          this.pagination.TotalAmount = response.TotalAmount;
          this.pagination.FilterInitialDueDate = response.FilterInitialDueDate;
          this.pagination.FilterFinalDueDate = response.FilterFinalDueDate;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as despesas",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    OpenModalUpdateToEnable: function (ev, idx) {
      ev.preventDefault();
      this.infoOutgoEnable = {
        InitialDate: null,
        Idx: idx,
      };
      this.$bvModal.show("mEnableOutgo");
    },
    ProcessUpdateEnabled: function (ev, idx, isEnabled) {
      if (isEnabled) {
        idx = this.infoOutgoEnable.Idx;
        this.$bvModal.hide("mEnableOutgo");
      }

      const outgo = this.accountsreceivable[idx];

      this.$makeMsgBox(
        `Você tem certeza que deseja ${isEnabled ? "ATIVAR" : "DESATIVAR"}
        a cobrança ${outgo.Description}?`,
        "Confirmar operação",
        this.UpdateEnabled,
        outgo.Id,
        isEnabled
      );
    },
    UpdateEnabled: function (id, isEnabled) {
      let outgo = {
        Id: id,
        IsEnabled: isEnabled,
      };
      if (isEnabled && hasValue(this.infoOutgoEnable.InitialDate))
        outgo["InitialDate"] = this.infoOutgoEnable.InitialDate;
      this.$store
        .dispatch("UpdateEnabledOutgo", outgo)
        .then(() => {
          this.$makeToast(
            `A despesa foi ${
              isEnabled ? "ativada" : "desativada"
            } com sucesso.`,
            "success",
            "Despesa fixa"
          );
          this.ListAccountsReceivable();
        })
        .catch((error) => {
          this.$makeToast(
            `Falha ao ${isEnabled ? "ativar" : "desativar"} a despesa.`,
            "danger",
            "Erro ao atualizar a despesa",
            error
          );
        });
    },
    ResetFilter: function () {
      this.filter = {
        FilterInitialDueDate: this.$options.filters.date(new Date().setDate(new Date().getDate()), "YYYY-MM-DD"),
        FilterFinalDueDate: this.$options.filters.date(new Date(new Date().setFullYear(new Date().getFullYear() + 1)), "YYYY-MM-DD"),
        Category: { Id: 0 },
        SupplierName: null,
        SupplierIdentity: null
      };
      this.ListAccountsReceivable();
    },




    ConfirmDeleteOutgo: function (e, i) {
      e.preventDefault();
      let deleted = this.accountsreceivable[i];
      this.$makeMsgBox(
        `Você tem certeza que deseja remover PERMANENTEMENTE ${deleted.Description}?`,
        "Confirmar EXCLUSÃO",
        this.DeleteOutgo,
        i
      );
    },
    DeleteOutgo: function (i) {
      let deleted = this.accountsreceivable[i];
      this.$store
        .dispatch("DeleteOutgo", { id: deleted.Id })
        .then(() => {
          this.$makeToast(
            `${deleted.Description} foi removido da sua lista de despesas`,
            "success",
            "Despesa fixa"
          );
          this.ListAccountsReceivable();
          this.$bvModal.hide("mFormOutgo");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover a despesa",
            error
          );
        });
    },
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.nav-steps .breadcrumb-item:before {
  content: none;
}
.nav-steps .breadcrumb-item .active {
  text-decoration: underline;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AccountsReceivable/accountsreceivable.vue